import { PLATFROMS_LANGUAGES } from '@/constants/languages'
import { IOption } from '@/types/selectOption.interface'
import type { ILanguage } from '@/types/task.interface'
import type { ISelectedPlatform } from '@/types/uploadForm.interface'

export const buildAvailableSourceLanguages = (
	selectedTranscribingLang: ILanguage | null,
	selectedPlatformList: ISelectedPlatform[],
	languages: ILanguage[]
): IOption[] => {
	const options: IOption[] = []

	if (selectedTranscribingLang?.language) {
		options.push({
			value: selectedTranscribingLang.code,
			label: selectedTranscribingLang.language
		})
	}

	for (const p of selectedPlatformList) {
		if (p.headerState !== 'done' || !p.result) continue

		const label = PLATFROMS_LANGUAGES[p.value]
		if (!label) continue

		const value = languages?.find(lang => lang.language === label)?.code

		options.push({
			value,
			label
		})
	}

	return Array.from(new Map(options.map(o => [o.value, o])).values())
}
